<template>
  <div id="EditEnterpriseMember" class="well" style="padding: 0 1em">
    <div v-if="show">
      <div class="course_title">修改企業會員資料</div>

      <div class="form-group">
        <table class="table" style="width: auto; align: left">
          <tbody>
            <tr>
              <td colspan="4" align="left">
                <span style="color: #f00"
                  ><span style="color: #f00">＊</span>為必填項目。</span
                >
              </td>
            </tr>
            <tr align="left">
              <td>公司名稱</td>
              <td>{{ queryInfo.ComName }}</td>
              <td></td>
              <td></td>
            </tr>
            <tr align="left">
              <td>會員性別</td>
              <td>{{ Sex_Array[queryInfo.Sex] }}</td>
              <td></td>
              <td></td>
            </tr>
            <tr align="left">
              <td>生日</td>
              <td>{{ Y1 }}年{{ M1 }}月{{ D1 }}日</td>
              <td></td>
              <td></td>
            </tr>
            <tr align="left">
              <td>統一編號(帳號)</td>
              <td>{{ queryInfo.IdNo }}</td>
              <td></td>
              <td></td>
            </tr>
            <tr align="left">
              <td><span class="red_star">＊</span>是否需要收據</td>
              <td>
                <div class="input-group-text">
                  <input
                    type="radio"
                    id="Receipt"
                    v-model="queryInfo.Receipt"
                    value="0"
                    aria-label="Radio button for following text input"
                  />是(收據抬頭為公司名稱/統一編號)

                  <input
                    type="radio"
                    id="Receipt"
                    v-model="queryInfo.Receipt"
                    value="1"
                    aria-label="Radio button for following text input"
                  />否
                </div>
              </td>
              <td></td>
              <td></td>
            </tr>
            <tr align="left">
              <td><span class="red_star">＊</span>公司電子信箱</td>
              <td>
                <input
                  type="email"
                  class="form-control"
                  v-model="queryInfo.ComEmail"
                  required
                />
              </td>
              <td></td>
              <td></td>
            </tr>
            <tr align="left">
              <td><span class="red_star">＊</span>公司連絡電話</td>
              <td>
                <input
                  type="Number"
                  class="form-control"
                  v-model="queryInfo.ComTel"
                  required
                />
              </td>
              <td><span class="red_star">範例(0412345678)</span></td>
              <td></td>
            </tr>
            <tr align="left">
              <td><span class="red_star">＊</span>連絡人姓名</td>
              <td>
                <input
                  type="text"
                  class="form-control"
                  v-model="queryInfo.Name"
                  required
                />
              </td>
              <td></td>
              <td></td>
            </tr>
            <tr align="left">
              <td><span class="red_star">＊</span>連絡人電話</td>
              <td>
                <input
                  type="Number"
                  class="form-control"
                  v-model="queryInfo.PhoneNo1"
                  required
                />
              </td>
              <td><span class="red_star">範例(0412345678)</span></td>
              <td></td>
            </tr>
            <tr align="left">
              <td><span class="red_star">＊</span>連絡人行動電話</td>
              <td>
                <input
                  type="Number"
                  class="form-control"
                  v-model="queryInfo.PhoneNo2"
                  pattern="/^-?\d+\.?\d*$/"
                  onKeyPress="if(this.value.length==10) return false;"
                  required
                />
              </td>
              <td></td>
              <td></td>
            </tr>
            <tr align="left">
              <td><span class="red_star">＊</span>連絡人電子信箱</td>
              <td>{{ queryInfo.EMail }}</td>
              <td></td>
              <td></td>
            </tr>

            <tr align="left">
              <td><span class="red_star">＊</span>交通工具</td>
              <td>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="queryInfo.TransportationArray"
                    value="0"
                    id="inlineCheckbox0"
                  />
                  <label class="form-check-label" for="0">公車</label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="queryInfo.TransportationArray"
                    value="1"
                    id="inlineCheckbox1"
                  />
                  <label class="form-check-label" for="1">機車</label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="queryInfo.TransportationArray"
                    value="2"
                    id="inlineCheckbox2"
                  />
                  <label class="form-check-label" for="2">汽車</label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="queryInfo.TransportationArray"
                    value="3"
                    id="inlineCheckbox3"
                  />
                  <label class="form-check-label" for="3">步行</label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="queryInfo.TransportationArray"
                    value="4"
                    id="inlineCheckbox4"
                  />
                  <label class="form-check-label" for="4">其他</label>
                </div>
              </td>
              <td></td>
              <td></td>
            </tr>
            <tr align="left">
              <td>車牌號碼(步行、公車不需填寫)</td>
              <td>
                <input
                  type="text"
                  class="form-control"
                  v-model="queryInfo.PlateNumber"
                  />
              </td>
              <td></td>
              <td></td>
            </tr>
            <tr align="left">
              <td><span class="red_star">＊</span>飲食習慣</td>
              <td>
                <div class="input-group-text">
                  <input
                    type="radio"
                    id="EatingHabits"
                    value="0"
                    v-model="queryInfo.EatingHabits"
                    aria-label="Radio button for following text input"
                  />葷

                  <input
                    type="radio"
                    id="EatingHabits"
                    value="1"
                    v-model="queryInfo.EatingHabits"
                    aria-label="Radio button for following text input"
                  />素
                </div>
              </td>
              <td></td>
              <td></td>
            </tr>
            <tr align="left">
              <td><span class="red_star">＊</span>優惠身分</td>
              <td>
                <div class="input-group-text">
                  <input
                    type="radio"
                    id="Offer"
                    value="0"
                    @click="mode = false"
                    checked
                    v-model="queryInfo.Offer"
                    aria-label="Radio button for following text input"
                  />無

                  <input
                    type="radio"
                    id="Offer"
                    value="1"
                    @click="mode = true"
                    v-model="queryInfo.Offer"
                    aria-label="Radio button for following text input"
                  />本校教職員工及親友（含退休）(9折)
                </div>
              </td>
              <td>
                <div v-if="mode">
                  <b-form-file
                    class="mb-2"
                    ref="file-input"
                    :no-drop="true"
                    :no-traverse="true"
                    v-model="file[0]"
                    @input="fileChange(0)"
                    placeholder="上傳親友證明"
                    accept="image/jpeg, image/png, image/gif, application/pdf"
                  ></b-form-file>
                  <span v-if="file[0].RowId != undefined">
                    <a
                      :href="'./WebApi/Common/GetDocumentFile/' + file[0].RowId"
                      target="_blank"
                    >
                      <img src="@/assets/images/disk.png" />
                    </a>
                    {{ file[0].RowId != undefined ? file[0].name : "" }}
                  </span>
                </div>
                <div v-else></div>
              </td>
              <td></td>
            </tr>
            <tr align="left">
              <td>服務單位/就讀學校</td>
              <td>
                <input
                  type="text"
                  class="form-control"
                  v-model="queryInfo.ServiceUnit"

                />
              </td>
              <td></td>
              <td></td>
            </tr>
            <tr align="left">
              <td><span class="red_star">＊</span>公司地址</td>
              <td>
                <input
                  type="text"
                  class="form-control"
                  v-model="queryInfo.MailAddress"

                />
              </td>
              <td></td>
              <td></td>
            </tr>

            <tr align="left">
              <td>訂閱電子報</td>
              <td>
                <input
                  type="checkbox"
                  v-model="queryInfo.EPaper"
                  aria-label="Checkbox for following text input"
                  required
                />訂閱
              </td>
              <td></td>
              <td></td>
            </tr>

            <tr align="left">
            <td colspan="4" align="center"  style="background:#CCC;">退費資訊</td>

          </tr>

             <tr align="left">
              <td><span class="red_star">＊</span>退費需求</td>
              <td>
                <div class="input-group-text">
                  <input
                    type="radio"
                    name="Refund"
                    value="0"
                    @click="RefundMode=false"
                    checked
                    v-model="queryInfo.Refund"
                    aria-label="Radio button for following text input"
                  />無

                  <input
                    type="radio"
                    name="Refund"
                    value="1"
                    @click="RefundMode=true"
                    v-model="queryInfo.Refund"
                    aria-label="Radio button for following text input"
                  />有
                </div>

              </td>
              <td>
                <div v-if="RefundMode">
                  <b-form-file
                    class="mb-2"
                    ref="file-input"
                    :no-drop="true"
                    :no-traverse="true"
                    v-model="RefundFile[0]"
                    @input="fileChange(1)"
                    placeholder="上傳退費存摺封面"
                    accept="image/jpeg, image/png, image/gif, application/pdf"
                  ></b-form-file>
                  <span v-if="RefundFile[0].RowId != undefined">
                    <a
                      :href="'./WebApi/Common/GetDocumentFile/' + RefundFile[0].RowId"
                      target="_blank"
                    >
                      <img src="@/assets/images/disk.png" />
                    </a>
                    {{ RefundFile[0].RowId != undefined ? RefundFile[0].name : "" }}
                  </span>
                </div>
                <div v-else></div>
              </td>
              <td></td>
            </tr>
            <tr align="left" v-if="RefundMode">
            <td>退費銀行名稱</td>
            <td>
              <input
                type="text"
                class="form-control"
                v-model="queryInfo.RefundBankName"

              />
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left" v-if="RefundMode">
            <td>退費銀行分行</td>
            <td>
              <input
                type="text"
                class="form-control"
                v-model="queryInfo.RefundBranchBank"

              />
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left" v-if="RefundMode">
            <td>退費銀行帳號(不用'-')</td>
            <td>
              <input
                type="text"
                class="form-control"
                v-model="queryInfo.RefundBankAccount"

              />
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left" v-if="RefundMode">
            <td>退費銀行戶名</td>
            <td>
              <input
                type="text"
                class="form-control"
                v-model="queryInfo.RefundBankAccountName"

              />
            </td>
            <td></td>
            <td></td>
          </tr>

            <tr align="left">
              <td colspan="4" align="center" style="background: #ccc">
                密碼更換(不改密碼請勿異動)
              </td>
            </tr>

            <tr align="left">
              <td>新密碼</td>
              <td>
                <input
                  type="password"
                  class="form-control"
                  v-model="newPsWord"
                  placeholder="新密碼"
                  minlength="8"
                />
              </td>
              <td><span class="red_star">英文數字至少8碼以上</span></td>
              <td></td>
            </tr>
            <tr align="left">
              <td>確認密碼</td>
              <td>
                <input
                  type="password"
                  class="form-control"
                  v-model="newPsWord2"
                  placeholder="確認密碼"
                  minlength="8"
                  @change="chkPasswd()"
                />
              </td>
              <td><span class="red_star">英文數字至少8碼以上</span></td>
              <td></td>
            </tr>
            <tr style="text-align: center">
              <td colspan="4" align="center">
                <button
                  class="btn active bg-info text-white rounded"
                  @click="editMember()"
                >
                  送出修改
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="frame_title" v-else>修改完成</div>
  </div>
</template>

<script>
import * as tools from '../tool'

export default {
  name: 'EditEnterpriseMember',
  props: ['IdNo', 'PsWord', 'StdID'],
  data () {
    return {
      show: true,
      mode: 0,
      file: [{ name: '', RowId: '' }],
      RefundMode: 0,
      RefundFile: [{ name: '', RowId: '' }],
      newPsWord: '',
      newPsWord2: '',
      Y1: '',
      M1: '',
      D1: '',
      Sex_Array: ['', '男', '女'],
      registerSuccessShow: 0,
      idCheckShow1: 0,
      idCheckShow: true,
      total: 0,
      isIE: false,
      inputData: null,
      selectedRowIndex: 0,
      currentPage: 1,
      pageSize: 10,
      captchaInfoArray: {
        text1: '',
        text2: '',
        text3: ''
      },
      captchaInfo: '',
      checkIdNo: '',
      attributesClassID: '', // 1:現職人才培育課程/2:專業證照課程/3:創客基地課程
      queryInfo: {
        StdID: 0,
        sysId: 0,
        Name: '',
        Sex: '',
        Birth: '',
        IdNo: '',
        EMail: '',
        ComName: '',
        ComEmail: '',
        ComTel: '',
        PsWord: '',
        PhoneNo1: '',
        PhoneNo2: '',
        MailAddress: '',
        VerifyCode: '',
        Agree: '',
        ServiceUnit: '',
        Transportation: '',
        TransportationArray: [],
        PlateNumber: '',
        EatingHabits: '',
        EPaper: '',
        Offer: '',
        Info: [],
        Info2: [],
        RowId: '',
        RefundRowId: '',
        Receipt: 0,
        Refund: 0,
        RefundBankName: '',
        RefundBranchBank: '',
        RefundBankAccount: '',
        RefundBankAccountName: ''
      }
    }
  },
  computed: {},
  methods: {
    isEmpty (data) {
      return !(data != null && data != undefined && data.length > 0)
    },
    checkSaveData () {
      var msg = ''

      if (this.isEmpty(this.queryInfo.ComEmail)) {
        msg = '請輸入公司電子信箱'
      } else if (this.isEmpty(this.queryInfo.ComTel)) {
        msg = '請輸入公司連絡電話'
      } else if (this.isEmpty(this.queryInfo.MailAddress)) {
        msg = '請輸入公司地址'
      } else if (this.isEmpty(this.queryInfo.Name)) {
        msg = '請輸入公司連絡人姓名'
      } else if (this.isEmpty(this.queryInfo.PhoneNo1)) {
        msg = '請輸入連絡人電話'
      } else if (this.isEmpty(this.queryInfo.PhoneNo2)) {
        msg = '請輸入連絡人行動電話'
      } else if (this.isEmpty(this.queryInfo.TransportationArray)) {
        msg = '請輸入交通工具'
      } else if (this.mode == 1 && this.isEmpty(this.file[0].name)) {
        msg = '請上傳優惠身分證明'
      } else if (this.RefundMode == 1 && this.isEmpty(this.RefundFile[0].name)) {
        msg = '請上傳退費存摺封面'
      } else if (this.RefundMode == 1 && this.isEmpty(this.queryInfo.RefundBankName)) {
        msg = '請輸入退費銀行名字'
      } else if (this.RefundMode == 1 && this.isEmpty(this.queryInfo.RefundBranchBank)) {
        msg = '請輸入退費銀行分行'
      } else if (this.RefundMode == 1 && this.isEmpty(this.queryInfo.RefundBankAccount)) {
        msg = '請輸入退費銀行帳號'
      } else if (this.RefundMode == 1 && this.isEmpty(this.queryInfo.RefundBankAccountName)) {
        msg = '請輸入退費銀行戶名'
      } else if (this.RefundMode == 1 && isNaN(this.queryInfo.RefundBankAccount)) {
        msg = '請輸入退費銀行帳號(全部是數字)'
      }

      return msg
    },

    fileChange (index) {
      var vm = this
      this.formData = new FormData()
      // this.formData.delete("header");

      if (index == 0) { this.formData.append('header', this.file[0]) } else { this.formData.append('header2', this.RefundFile[0]) }

      this.$http
        .post('./WebApi/Common/UploadV2', this.formData)
        .then((response) => {
          if (!tools.isNull(response.data)) {
            if (index == 0) { vm.queryInfo.Info.push(response.data[0]) } else { vm.queryInfo.Info2.push(response.data[0]) }
          } else {
            tools.showAlert(vm, 'danger', '上傳檔案失敗，請重新上傳' + error)
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '網路連線失敗，請重新上傳' + error)
        })
    },
    editMember: function () {
      var msg = this.checkSaveData()
      if (msg.length != 0) {
        alert(msg)
        return null
      }

      const vm = this
      this.queryInfo.IdNo = vm.$props.IdNo
      this.queryInfo.Transportation =
        this.queryInfo.TransportationArray.toString()
      if (this.newPsWord != '') this.queryInfo.PsWord = this.newPsWord
      this.$http
        .put('./WebApi/ociaRep/EditociaRepGeneralMember/', this.queryInfo)
        .then((response) => {
          if (response.data > 0) {
            // tools.showAlert(vm, "success", "恭喜您,存檔成功");
            // window.location.replace("http://localhost:8080/");
            this.show = false
            // alert('修改完成!!');
            // this.show = true;
            // window.location.replace("/");
          } else {
            alert('修改失敗!!')
            // window.location.replace("/");
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
        })
    },

    chkPasswd () {
      var vm = this
      if (vm.newPsWord != vm.newPsWord2) {
        tools.showAlert(vm, 'danger', '對不起,請確認密碼是否正確')
        vm.$refs.newPsWord2.focus()
      }
      if (vm.newPsWord.length < 8 || vm.newPsWord2.length < 8) {
        tools.showAlert(vm, 'danger', '對不起,請確認密碼長度是否小於8')
        vm.$refs.newPsWord2.focus()
      }

      return null
    }
  },
  created () {
    console.log('======created View =====')

    const vm = this
    var url = ''
    if (this.$props.StdID == undefined) { url = './WebApi/ociaRep/GetociaRepCheckLogin/'.concat(vm.$props.IdNo + '/' + vm.$props.PsWord) } else { url = './WebApi/ociaRep/GetociaRepCheckByStdID/'.concat(this.$props.StdID) }

    this.$http
      .get(url)
      .then((response) => {
        if (response.data[0].name != null) {
          //   vm.queryInfo = response.data;
          vm.queryInfo.StdID = response.data[0].stdID
          vm.queryInfo.Name = response.data[0].name
          vm.queryInfo.IdNo = vm.$props.IdNo
          vm.queryInfo.EMail = response.data[0].eMail
          vm.queryInfo.ComName = response.data[0].comName
          vm.queryInfo.ComEmail = response.data[0].comEmail
          vm.queryInfo.ComTel = response.data[0].comTel
          vm.queryInfo.Sex = response.data[0].sex
          vm.queryInfo.Birth = response.data[0].birth
          vm.queryInfo.PhoneNo1 = response.data[0].phoneNo1
          vm.queryInfo.PhoneNo2 = response.data[0].phoneNo2
          vm.queryInfo.PsWord = response.data[0].psWord
          if (response.data[0].transportation != null) { vm.queryInfo.TransportationArray = response.data[0].transportation.split(',') }

          vm.queryInfo.PlateNumber = response.data[0].plateNumber
          vm.queryInfo.EatingHabits = response.data[0].eatingHabits
          vm.queryInfo.ServiceUnit = response.data[0].serviceUnit
          vm.queryInfo.MailAddress = response.data[0].mailAddress
          vm.queryInfo.EPaper = response.data[0].ePaper
          vm.queryInfo.Offer = response.data[0].offer
          vm.queryInfo.Refund = response.data[0].refund
          if (vm.queryInfo.Refund == 1) { vm.RefundMode = 1 }

          vm.queryInfo.RefundBankName = response.data[0].refundBankName
          vm.queryInfo.RefundBranchBank = response.data[0].refundBranchBank
          vm.queryInfo.RefundBankAccount = response.data[0].refundBankAccount
          vm.queryInfo.RefundBankAccountName = response.data[0].refundBankAccountName
          vm.mode = response.data[0].offer
          vm.queryInfo.Receipt = response.data[0].receipt

          if (response.data[0].attachInfoString != null) {
            const jsonArr = JSON.parse(response.data[0].attachInfoString)
            vm.file[0].name = jsonArr.FileNm
            vm.file[0].RowId = jsonArr.RowId
            vm.queryInfo.RowId = vm.file[0].RowId
          }

          if (response.data[0].refundAttachInfoString != null) {
            const jsonArr2 = JSON.parse(response.data[0].refundAttachInfoString)
            vm.RefundFile[0].name = jsonArr2.FileNm
            vm.RefundFile[0].RowId = jsonArr2.RowId
            vm.queryInfo.RefundRowId = vm.RefundFile[0].RowId
          }
          var Birth2 = new Date(vm.queryInfo.Birth)
          vm.Y1 = Birth2.getFullYear()
          vm.M1 = Birth2.getMonth() + 1
          vm.D1 = Birth2.getDate()
        } else {
          alert('對不起,帳號或密碼錯誤,請重新輸入')
        }
      })
      .catch(function (error) {
        alert('對不起,網路連線失敗,請重新輸入' + error)
        // tools.showAlert(vm, "danger", "網路連線失敗" + error);
      })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
